import { Search } from "semantic-ui-react";

interface IBWSearchBoxProps {
  isGreaterThanMobile?;
  short?;
}

const BWSearchBox = ({ ...props }: IBWSearchBoxProps) => {
  const handleSearch = () => console.log("Using Search Box"); // TODO: Search box functionality
  return (
    <Search
      open={false}
      onSearchChange={() => handleSearch()}
      placeholder="Search"
      className={props.short ? "bc-search-input-short" : ""}
    />
  );
};

export default BWSearchBox;